import makeApiCall from "./axiosIndex";

const consultantsApis= {
  fetchConsultants: (): Promise<any> =>
    makeApiCall<any>({ method: "get", url: "/buyer/fetchConsultant" }),
  deleteConsultantById: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "delete",
      url: `/buyer/deleteConsultantById?id=${id}`,
    }),
  createConsultant: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: "/buyer/createConsultant",
      data,
    }),
  updateConsultantById: (id: any, data: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/buyer/updateConsultantById`,
      params: { id },
      data,
    }),
  fetchConsultantById: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/buyer/fetchConsultantById`,
      params: { id },
    }),
};

export default consultantsApis;
